export default "__VITE_ASSET__Dg38Re86__"